// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bck_a bie_a bie_q bie_j bie_wl bie_bj","ImgResponsive__img":"bck_b bie_b bie_ql"};